import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'src/app/Service/data.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public isError = false;
  public acceso = false;
  public usuario: Usuario = new Usuario();
  public alerta: string = '';

  public mostrarPassword: boolean = false;

  constructor(public authservice: AuthService, private router: Router, private data: DataService) { }

  ngOnInit() {
    this.acceso = this.authservice.IsLogInOn;
    if (this.authservice.getCurrentUser() != null) {
      this.router.navigateByUrl('/');
    }
  }


  //enviar datos de validacion para inciar session
  onSubmit(d) {
    this.data.selectPost(this.data.api.usuario, 'lgin', '', d).subscribe(r => {
      if (this.data.Exists(r)) {
        r.clave = 'ninguno';
        this.authservice.setUser(r);

        this.router.navigateByUrl('ventas');
      }
    }, e => { console.log(e.error) });
  }

  LogIn() {
    this.data.selectPost(this.data.api.login, '', null, this.usuario).subscribe(r => {
      if (r.status != "success") {
        this.alerta = 'Usuario o contraseña incorrecta, por favor vuelva a ingresar las credenciales correctas';
        setTimeout(() => {
          this.alerta = '';
        }, 5000);

      } else {

        console.log(r.message);
        this.authservice.setUser(r.data);
        this.data.setSucursalId(r.data.idpersonal.idsucursal)

        this.router.navigateByUrl('/ventas').then(() => {
          // Una vez que se navega correctamente a /ventas, recargamos
          window.location.reload();
        });


      }
    }, e => {
      if (e.status == 404) {
        this.alerta = 'Usuario o contraseña incorrecta, por favor vuelva a ingresar las credenciales correctas';
        setTimeout(() => {
          this.alerta = '';
        }, 5000);
      } else { console.log(e.error.text); }
    });
  }


  onIsError(): void {
    this.isError = true;
    setTimeout(() => {
      this.isError = false;
    }, 4000);
  }

  togglePassword() {
    this.mostrarPassword = !this.mostrarPassword;
  }
}
